import * as React from 'react';
import { Flex } from "../../flex";
import { Box } from "../../box";
import { Heading } from "../../heading";
import { useMenuContext } from "../useMenuContext";
import { getSectionBaseStyles, getSectionTitleStyles } from "./MenuSection.styles";
export var MenuSection = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var title = props.title,
      children = props.children,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'outline' : _props$appearance;

  var _useMenuContext = useMenuContext(),
      palette = _useMenuContext.palette;

  return /*#__PURE__*/React.createElement(Flex, {
    ref: ref,
    alignItems: "baseline",
    flexDirection: "column",
    width: "100%",
    _getBaseStyle: function _getBaseStyle() {
      return getSectionBaseStyles({
        palette: palette
      });
    }
  }, /*#__PURE__*/React.createElement(Box, {
    py: 2,
    px: 4,
    width: "100%",
    _getBaseStyle: function _getBaseStyle() {
      return getSectionTitleStyles({
        palette: palette,
        appearance: appearance
      });
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "regular"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, " ", children, " "));
});
MenuSection.displayName = 'MenuSection';